import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NotifierService } from 'angular-notifier';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MatSort } from '@angular/material/sort';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-notes',
  templateUrl: './payments-manager.component.html',
  styleUrls: ['./payments-manager.component.scss']
})
export class PaymentsManagerComponent implements OnInit, AfterViewInit {
  students = [];
  studentSuggestions = [];
  addPaymentForm: FormGroup | null = null;
  addPaymentClicked = false;
  addPaymentError = false;
  statusFilter = '2';
  statusOptions: { label: string; value: string }[] = [
    { label: 'All', value: '' },
    { label: 'Pending', value: '2' },
    { label: 'Success', value: '3' },
    { label: 'Failed', value: '4' },
    { label: 'Paid', value: '5' },
    { label: 'Processing', value: '6' },
    { label: 'Subscription Pending', value: '7' },
    { label: 'Subscription Active', value: '8' },
    { label: 'Subscription Failed', value: '9' },
    { label: 'Subscription Processing', value: '10' },
    { label: 'Last Installment Fail', value: '11' },
    { label: 'Subscription Complete', value: '12' },
    { label: 'Subscription Cancelled', value: '15' },
    { label: 'In Progress (Checkout)', value: '16' },
    { label: 'In Progress (Subscription)', value: '17' }
  ];
  orderByFilter = 'desc';
  role = localStorage['roleId'];
  searchStudent: any = null;
  payments: any = new MatTableDataSource(<any>[]);
  @ViewChild(MatSort, { static: true }) sort: MatSort | undefined;
  selectedPayments: any[] = [];
  addPaymentVisible = false;
  columnsToDisplay = [
    // 'action',
    'studentName',
    'description',
    'dueBy',
    'installment',
    // 'intervalType',
    // 'interval',
    'noOfInstallments',
    // 'amount',
    // 'discount',
    'finalAmount',
    'paidAmount',
    'dueAmount',
    'status',
    'paymentType',
    'details'
  ];
  today: Date = new Date();
  paymentTypes: any[] = [];
  numbers: number[] = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  stripePaymentId: number | null = null;
  showPaymentDetails: boolean = false;
  selectedPayment: any = null;
  totalPayments: number = 0;
  private readonly notifier: NotifierService;
  pageIndex: number = 0;
  @ViewChild(MatPaginator, { static: true }) paginator:
    | MatPaginator
    | undefined;
  showGetPayment: boolean = false;
  isMobile: boolean = window.innerWidth < 540;
  paymentOptions: any[] = [
    { label: 'Installments', value: 1 },
    { label: 'Pay In Full', value: 0 }
  ];
  isPaymentOrInstallment: number = 1;
  termCheck1: boolean = false;
  installmentDates: string[] = [];
  getPaymentUrlClicked: boolean = false;
  showLoader: boolean = false;
  fullPaymentLink: string = '';
  subscriptionLink: string = '';
  showCancelSubscriptionDialog: boolean = false;
  cancelSubscriptionClicked: boolean = false;
  cancelSubscriptionRefundOption: 'NO_REFUND' | 'LAST_PAID_AMOUNT' =
    'NO_REFUND';
  paymentToCancel: any = null;
  showDeleteInvoiceDialog: boolean = false;
  deleteInvoiceClicked: boolean = false;
  paymentToDelete: any = null;
  constructor(
    private globalApiService: GlobalApiService,
    notifierService: NotifierService,
    private route: ActivatedRoute
  ) {
    this.notifier = notifierService;
    this.route.queryParams.subscribe((params: Params) => {
      console.log('query params are: ', params);
      if ('paymentMethodUpdate' in params) {
        if (params?.['paymentMethodUpdate'] === 'success') {
          if (
            localStorage.getItem('invoiceId') !== null &&
            localStorage.getItem('cSessionId') !== null
          ) {
            this.confirmTheUpdatePaymentMethod();
          }
        } else {
          this.notifier.notify('error', 'Payment Method Update Failed.');
        }
      }
    });
  }

  ngOnInit() {
    // this.payments.paginator = this.paginator;
    this.getStudents();
    this.getPaymentTypes();
    this.getPayments(0);
  }

  ngAfterViewInit(): void {
    this.payments.paginator = this.paginator;
  }

  getStudents() {
    this.globalApiService.getAllStudents().subscribe(
      (response: any) => {
        console.log(response);
        const students = JSON.parse(response.data) || [];
        this.students = students.map((student: any) => {
          student.name = `${student.first_name} ${student.last_name}`;
          return student;
        });
      },
      (error) => {}
    );
  }

  getPaymentTypes() {
    this.globalApiService.getPaymentTypes().subscribe(
      (response: any) => {
        console.log(response);
        this.paymentTypes = response;
        const stripePayment = this.paymentTypes.find(
          (paymentType: any) =>
            paymentType.paymentTypeName === 'Stripe - Online Payment'
        );
        if (stripePayment) {
          this.stripePaymentId = stripePayment.paymentTypeId;
          console.log(this.stripePaymentId);
        }
      },
      (error) => {
        console.log(error);
        this.notifier.notify('error', 'Unable to fetch payment types');
      }
    );
  }

  openNewPayment() {
    this.addPaymentError = false;
    this.paymentFormInit();
    this.selectedPayment = null;
    this.addPaymentVisible = !this.addPaymentVisible;
  }

  openPayment(isExisting: boolean) {
    this.addPaymentError = false;
    if (!isExisting) {
      this.selectedPayment = null;
    }
    this.paymentFormInit();
    this.addPaymentVisible = !this.addPaymentVisible;
  }

  paymentFormInit() {
    if (this.selectedPayment) {
      this.studentSuggestions = this.students;
      const student = this.studentSuggestions.find((student: any) => {
        return student.student_id === this.selectedPayment.studentId;
      });
      console.log(student, this.selectedPayment);
      this.addPaymentForm = new FormGroup({
        student: new FormControl(student || null, [Validators.required]),
        amount: new FormControl(this.selectedPayment.amount || '', [
          Validators.required,
          Validators.min(1)
        ]),
        description: new FormControl(this.selectedPayment.description || ''),
        dueBy: new FormControl(new Date(this.selectedPayment.dueDate) || null, [
          Validators.required
        ]),
        paidFor: new FormControl(this.selectedPayment.paidFor || null),
        copyParent: new FormControl(this.selectedPayment.sendToParent || true),
        onlyParent: new FormControl(
          !this.selectedPayment.sendToStudent || false
        ),
        installment: new FormControl(
          this.selectedPayment.allowInstallment || false
        ),
        intervalType: new FormControl(
          this.selectedPayment.recurringInterval || null
        ),
        interval: new FormControl(
          this.selectedPayment.recurringIntervalCount || null
        ),
        noOfInstallments: new FormControl(
          this.selectedPayment.iterations || null
        ),
        alreadyPaid: new FormControl(false),
        paymentType: new FormControl(null),
        discount: new FormControl(this.selectedPayment.discount || 0),
        transactionCharges: new FormControl(
          this.selectedPayment.transactionCharges || null
        )
      });
      console.log(this.addPaymentForm);
    } else {
      this.addPaymentForm = new FormGroup({
        student: new FormControl(null, [Validators.required]),
        amount: new FormControl(0, [Validators.required, Validators.min(1)]),
        description: new FormControl(''),
        dueBy: new FormControl(null, [Validators.required]),
        paidFor: new FormControl(null),
        copyParent: new FormControl(true),
        onlyParent: new FormControl(false),
        installment: new FormControl(false),
        intervalType: new FormControl(null),
        interval: new FormControl(null),
        noOfInstallments: new FormControl(null),
        alreadyPaid: new FormControl(false),
        paymentType: new FormControl(null),
        discount: new FormControl(0),
        transactionCharges: new FormControl(null)
      });
    }
  }

  getPayments(pageNo: number) {
    console.log("I'm triggered");
    console.log("I'm triggered");
    this.showLoader = true;
    this.globalApiService
      .getPaymentsForAdmin(
        this.searchStudent ? this.searchStudent.student_id : '',
        this.statusFilter,
        this.orderByFilter,
        pageNo
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          let payments = response.invoiceInfoList || [];
          this.totalPayments = response.totalElements;
          this.showLoader = false;
          payments.forEach((payment: any) => {
            payment.dueBy = moment(payment.dueDate, 'MM-DD-YYYY').format(
              'MM-DD-YYYY'
            );
            payment.dueDate = moment(payment.dueDate, 'MM-DD-YYYY').format(
              'YYYY-MM-DD'
            );
            // payment.paidFor = payment.paidFor
            //   ? moment(payment.paidFor).format('MMM YYYY')
            //   : '';
            payment.finalAmount = payment.amount - payment.discount;
            payment.paidAmount = 0;
            payment.dueAmount = payment.finalAmount.toFixed(2);
            let paidAmount = 0;
            if (payment.paymentDetails.transactions) {
              payment.paymentDetails.transactions =
                payment.paymentDetails.transactions.filter(
                  (transaction: any) => {
                    if (
                      transaction.paymentStatus !== 10 &&
                      transaction.paymentStatus !== 6
                    ) {
                      transaction.date = moment(
                        transaction?.transactionDate
                      ).format('MM-DD-YYYY');
                      return true;
                    } else {
                      return false;
                    }
                  }
                );
              const paidTransactions =
                payment.paymentDetails.transactions.filter(
                  (transaction: any) => {
                    return (
                      transaction.paymentStatus !== 4 &&
                      transaction.paymentStatus !== 9 &&
                      transaction.paymentStatus !== 15
                    );
                  }
                );
              // ** only a cancellation that actually refunded money
              // ** (amountReceived < 0) cancels out the most recent paid
              // ** installment; a cancellation with amountReceived === 0
              // ** didn't refund anything, so the prior payment still counts.
              // ** the refund transaction's own amountReceived is never summed
              // ** directly - it bundles the transaction charge into one
              // ** negative figure, unlike a paid installment's amountReceived
              // ** which excludes the charge, so summing both would understate
              // ** paidAmount by the charge
              const refundedTransactionsCount =
                payment.paymentDetails.transactions.filter(
                  (transaction: any) =>
                    transaction.paymentStatus === 15 &&
                    transaction.amountReceived < 0
                ).length;
              payment.paymentDetails.successfulTransactions =
                paidTransactions.slice(
                  0,
                  Math.max(
                    0,
                    paidTransactions.length - refundedTransactionsCount
                  )
                );
              paidAmount = payment.paymentDetails.successfulTransactions.reduce(
                (sum: number, transaction: any) =>
                  sum + transaction.amountReceived,
                0
              );
            }
            // if (payment.paymentDetails.isInstallmentPayment) {
            //   payment.finalAmount +=
            //     payment.iterations * payment.transactionCharges;
            // }
            payment.paidAmount = paidAmount;
            payment.dueAmount = (payment.finalAmount - paidAmount).toFixed(2);
            // ** Added for paymentType - 5
            if (payment.status === '5') {
              payment.dueAmount = 0;
              payment.paidAmount = payment.finalAmount;
            }
          });
          console.log(payments);
          this.selectedPayments = [];
          this.payments = new MatTableDataSource(payments);
          // this.payments.paginator = this.paginator;
          // this.payments.paginator.pageNo = pageNo + 1;
          this.payments.sort = this.sort;
          this.totalPayments = response.totalElements;
          this.pageIndex = pageNo;
          // this.paginator!.length = this.totalPayments;
          // this.payments.paginator.length = this.totalPayments;
          console.log(this.totalPayments);
        },
        (error) => {
          this.showLoader = false;
        }
      );
  }

  filterUsers(event: any) {
    this.studentSuggestions = this.students.filter(
      (student: any) =>
        (student.first_name
          ? student.first_name.toLowerCase().includes(event.query.toLowerCase())
          : false) ||
        (student.last_name
          ? student.last_name.toLowerCase().includes(event.query.toLowerCase())
          : false) ||
        (student.email
          ? student.email.toLowerCase().includes(event.query.toLowerCase())
          : false)
    );
  }

  setNoteStatus(status: any) {
    this.addPaymentForm!.controls['status'].setValue(status);
  }

  addPayment() {
    console.log(this.addPaymentForm, this.stripePaymentId);
    this.addPaymentClicked = true;
    if (this.addPaymentForm!.valid) {
      if (
        this.addPaymentForm!.value.amount > this.addPaymentForm!.value.discount
      ) {
        this.addPaymentError = false;
        const paymentForm = this.addPaymentForm!.value;
        const paymentData = {
          studentId: paymentForm.student.student_id,
          amount: paymentForm.amount,
          description: paymentForm.description,
          dueDate: moment(paymentForm.dueBy).format('MM-DD-YYYY'),
          paidFor: paymentForm.paidFor
            ? moment(paymentForm.paidFor).format('MM-DD-YYYY')
            : null,
          sendToParent: paymentForm.copyParent,
          sendToStudent: !paymentForm.onlyParent,
          allowInstallment: paymentForm.installment,
          recurringInterval: paymentForm.installment
            ? paymentForm.intervalType
            : null,
          recurringIntervalCount: paymentForm.installment
            ? paymentForm.interval
            : null,
          iterations: paymentForm.installment
            ? paymentForm.noOfInstallments
            : null,
          paymentTypeId: paymentForm.alreadyPaid
            ? paymentForm.paymentType
            : this.stripePaymentId,
          alreadyPaid: paymentForm.alreadyPaid,
          discount: paymentForm.discount,
          transactionCharges: paymentForm.installment
            ? paymentForm.transactionCharges
            : 0,
          isBackDate: moment(new Date()).isAfter(moment(paymentForm.dueBy))
        };
        console.log(paymentData);
        if (!this.selectedPayment) {
          this.globalApiService.createPayment(paymentData).subscribe(
            (response) => {
              this.notifier.notify('success', 'Payment created successfully!');
              this.addPaymentClicked = false;
              this.addPaymentVisible = false;
              this.paymentFormInit();
              this.getPayments(0);
            },
            (error) => {
              this.notifier.notify('error', 'Unable to create payment');
              this.addPaymentClicked = false;
            }
          );
        } else {
          this.updatePayment(paymentData);
        }
      } else {
        this.addPaymentError = true;
        this.addPaymentClicked = false;
        this.notifier.notify('error', 'Amount should be greater than discount');
      }
    } else {
      this.addPaymentError = true;
      this.addPaymentClicked = false;
    }
  }

  selectNote(noteId: any) {
    const noteIndex = this.selectedPayments.indexOf(noteId);
    if (noteIndex >= 0) {
      this.selectedPayments.splice(noteIndex, 1);
    } else {
      this.selectedPayments.push(noteId);
    }
    console.log(this.selectedPayments);
  }

  toggleValidation(event: any, controlType: string) {
    const control = this.addPaymentForm!.controls[controlType];
    if (event.checked) {
      control.setValidators([Validators.required]);
    } else {
      console.log('Clearing validator');
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }

  toggleInstallmentValidation(event: any) {
    const intervalControl = this.addPaymentForm!.controls['interval'];
    const intervalTypeControl = this.addPaymentForm!.controls['intervalType'];
    const noOfInstallmentsControl =
      this.addPaymentForm!.controls['noOfInstallments'];
    if (event.checked) {
      intervalControl.setValidators([Validators.required, Validators.min(1)]);
      intervalTypeControl.setValidators([Validators.required]);
      noOfInstallmentsControl.setValidators([
        Validators.min(2),
        Validators.required
      ]);
    } else {
      intervalControl.clearValidators();
      intervalTypeControl.clearValidators();
      noOfInstallmentsControl.clearValidators();
    }
    intervalControl.updateValueAndValidity();
    intervalTypeControl.updateValueAndValidity();
    noOfInstallmentsControl.updateValueAndValidity();
  }

  selectMonth(event: any, datePicker: any) {
    this.addPaymentForm!['controls']['paidFor'].setValue(event);
    datePicker.close();
  }

  getDate(date: any, dateType: any) {
    const modifiedDate = date
      ? dateType === 'month'
        ? moment(date).format('MMM-YYYY')
        : moment(date).format('MM-DD-YYYY')
      : '';
    return modifiedDate;
  }

  getPaymentType(typeId: any) {
    const paymentIndex = this.paymentTypes.findIndex(
      (type) => type['paymentTypeId'] === typeId
    );
    return paymentIndex > -1
      ? this.paymentTypes[paymentIndex]['paymentTypeName']
      : '';
  }

  getStatus(status: any) {
    switch (status) {
      case '1':
      case '2':
        return 'Pending';
      case '3':
        return 'Success';
      case '4':
        return 'Failed';
      case '5':
        return 'Paid';
      case '6':
        return 'Processing';
      case '7':
        return 'Subscription Pending';
      case '8':
        return 'Subscription Active';
      case '9':
        return 'Subscription Failed';
      case '10':
        return 'Subscription Processing';
      case '11':
        return 'Last Installment Fail';
      case '12':
        return 'Subscription Complete';
      case '15':
        return 'Subscription Cancelled';
      case '16':
        return 'In Progress';
      case '17':
        return 'In Progress';
      default:
        return '';
    }
  }

  getNextInstallment() {
    if (!this.selectedPayment.paymentDetails.successfulTransactions?.length) {
      return moment(this.selectedPayment.dueDate).format('MM-DD-YYYY');
    }
    const date = moment(this.selectedPayment.dueDate).isBefore(
      this.selectedPayment.paymentDetails.successfulTransactions[0]
        ?.transactionDate
    )
      ? moment(this.selectedPayment.dueDate)
      : moment(
          this.selectedPayment.paymentDetails.successfulTransactions[0]
            .transactionDate
        );
    console.log(date.clone());
    date.add(
      this.selectedPayment.paymentDetails.successfulTransactions.length *
        this.selectedPayment.recurringIntervalCount,
      this.selectedPayment.recurringInterval
    );
    return date ? date.format('MM-DD-YYYY') : '';
  }

  getPageData(event: PageEvent) {
    console.log(event);
    this.getPayments(event.pageIndex);
  }

  getAmountByInstallment(isInstallmentTotal: boolean): string {
    console.log(this.isPaymentOrInstallment);
    let returnAmount = 0;
    returnAmount =
      this.selectedPayment!.amount - this.selectedPayment!.discount;
    if (this.isPaymentOrInstallment === 1) {
      returnAmount = returnAmount / this.selectedPayment!.iterations;
    }
    if (isInstallmentTotal) {
      returnAmount = returnAmount * this.selectedPayment!.iterations;
    }
    return returnAmount.toFixed(2);
  }

  openDueModal(payment: any) {
    this.selectedPayment = payment;
    this.isPaymentOrInstallment = payment.allowInstallment ? 1 : 0;
    this.termCheck1 = false;
    this.makeInstalmentDates();
    this.fullPaymentLink = '';
    this.subscriptionLink = '';
    this.showGetPayment = true;
  }

  makeInstalmentDates() {
    this.installmentDates = [];
    let installmentDate = moment(this.selectedPayment?.dueDate).isBefore(
      moment(new Date())
    )
      ? moment(this.selectedPayment?.dueDate)
      : moment(new Date());
    this.installmentDates.push(installmentDate.format('MM/DD/YYYY'));
    const recurringInterval: any = this.selectedPayment?.recurringInterval;
    for (let i = 1; i < this.selectedPayment!.iterations; i++) {
      const installmentDateClone = installmentDate.clone();
      this.installmentDates.push(
        installmentDateClone
          .add(
            i * this.selectedPayment!.recurringIntervalCount,
            recurringInterval
          )
          .format('MM/DD/YYYY')
      );
    }
  }

  installmentPay() {
    if (this.isPaymentOrInstallment === 0) {
      this.getPaymentUrl(this.selectedPayment!.invoiceId);
    } else if (this.isPaymentOrInstallment === 1) {
      console.log('in installment pay');
      if (this.termCheck1) {
        this.showLoader = true;
        this.globalApiService
          .payByInstallments(this.selectedPayment!.invoiceId)
          .subscribe({
            next: (response: any) => {
              console.log('Subscription info ', response);
              this.showLoader = false;
              this.subscriptionLink = `${
                environment.location
              }/#/stripe-payment/pay?invoiceId=${
                this.selectedPayment!.invoiceId
              }&paymentId=${response.data.clientSecret}`;
              var paymentDiv = document.getElementsByClassName(
                'payNowDialog-content'
              );
              setTimeout(() => {
                if (paymentDiv[0])
                  paymentDiv[0].scrollTop = paymentDiv[0].scrollHeight;
              }, 100);
            },
            error: (error) => {
              this.showLoader = false;
              console.log(error);
              this.notifier.notify('error', 'Unable to generate payment link');
            }
          });
      } else {
        this.notifier.notify('error', `Please agree to the T&C's`);
      }
    }
  }

  getPaymentUrl(invoiceId: string) {
    if (this.termCheck1) {
      if (!this.getPaymentUrlClicked) {
        this.getPaymentUrlClicked = true;
        this.showLoader = true;
        this.globalApiService.getPaymentUrl(invoiceId).subscribe(
          (response: any) => {
            console.log(response);
            this.getPaymentUrlClicked = false;
            this.showLoader = false;
            if (response.data) {
              this.fullPaymentLink = response.data;
              var paymentDiv = document.getElementsByClassName(
                'payNowDialog-content'
              );
              setTimeout(() => {
                if (paymentDiv[0])
                  paymentDiv[0].scrollTop = paymentDiv[0].scrollHeight;
              }, 100);
            }
          },
          (error) => {
            this.getPaymentUrlClicked = false;
            this.showLoader = false;
            console.log(error);
            this.notifier.notify('error', 'Unable to generate payment link');
          }
        );
      }
    } else {
      this.notifier.notify('error', `Please agree to the T&C's`);
    }
  }

  linkCopied(event: any) {
    if (event) {
      this.notifier.notify('success', 'Link copied to clipboard');
    } else {
      this.notifier.notify('error', 'Unable to copy link');
    }
  }

  updatePayment(paymentInfo: any) {
    paymentInfo.invoiceId = this.selectedPayment.invoiceId;
    this.globalApiService.updatePayment(paymentInfo).subscribe({
      next: (response: any) => {
        this.addPaymentClicked = false;
        this.notifier.notify('success', 'Payment updated successfully!');
        this.addPaymentVisible = false;
        this.getPayments(0);
      },
      error: (error: any) => {
        this.addPaymentClicked = false;
        this.notifier.notify('error', 'Unable to update payment');
      }
    });
  }

  getTransactionCharge(isInstallmentTotal: boolean): string {
    let returnTransactionCharge: string = '';
    if (isInstallmentTotal) {
      returnTransactionCharge = (
        this.selectedPayment!.transactionCharges *
          this.selectedPayment!.iterations +
        parseFloat(this.getAmountByInstallment(true))
      ).toFixed(2);
    } else {
      returnTransactionCharge = (
        this.selectedPayment!.transactionCharges +
        parseFloat(this.getAmountByInstallment(false))
      ).toFixed(2);
    }
    return returnTransactionCharge;
  }

  updatePaymentMethod(payment: any): void {
    console.log('udpatePaymentMethod trigegred!');
    this.showLoader = true;
    console.log('payment: ', payment);
    const invoiceId = payment?.paymentDetails?.invoiceId;
    console.log('invoice id: ', invoiceId);
    this.globalApiService.updatePaymentMethod(invoiceId).subscribe({
      next: (resposne) => {
        this.showLoader = false;
        const data = resposne?.data;
        localStorage.setItem('cSessionId', data?.cSessionId);
        localStorage.setItem('invoiceId', data?.invoiceId);
        window.open(data?.checkoutUrl, '_blank');
      },
      error: (err: any) => {
        console.error('error: ', err);
        this.showLoader = false;
        this.notifier.notify('error', 'Unable to update the payment method.');
      }
    });
  }

  confirmTheUpdatePaymentMethod() {
    const invoiceId = localStorage.getItem('invoiceId');
    const cSessionId = localStorage.getItem('cSessionId');
    console.log('invoiceId, CsessionId are: ', invoiceId, cSessionId);
    this.globalApiService
      .confirmTheUpdatePaymentMethod(invoiceId!, cSessionId!)
      .subscribe({
        next: (response) => {
          this.notifier.notify(
            'success',
            'Payment Method Updated Successfully.'
          );
          localStorage.removeItem('invoiceId');
          localStorage.removeItem('cSessionId');
        },
        error: (err) => {
          console.log(err);
          this.notifier.notify(
            'error',
            'Payment Method Update Failed! Unable to Confirm the Updation.'
          );
        }
      });
  }

  downloadInvoice(transaction: any): void {
    console.log('downloadInvoice triggered!!');
    this.showLoader = true;
    console.log('selectedTransaction: ', transaction);
    this.globalApiService.downloadInvoice(transaction?.receiptId).subscribe({
      next: (response) => {
        this.showLoader = false;
        console.log('response - downloadInvocie: ', response);
        const data = response?.data;
        window.open(data?.invoiceUrl, '_blank');
      },
      error: (err) => {
        this.showLoader = false;
        console.log('err - download invoice: ', err);
        this.notifier.notify('error', 'Unable to download the invoice.');
      }
    });
  }

  getLastPaymentAmount(): string {
    const transactions =
      this.paymentToCancel?.paymentDetails?.successfulTransactions;
    if (transactions && transactions.length > 0) {
      return transactions[transactions.length - 1].amountReceived.toFixed(2);
    }
    return '';
  }

  openCancelSubscriptionModal(payment: any): void {
    this.paymentToCancel = payment;
    this.cancelSubscriptionRefundOption = 'NO_REFUND';
    this.showCancelSubscriptionDialog = true;
  }

  closeCancelSubscriptionModal(): void {
    this.showCancelSubscriptionDialog = false;
    this.paymentToCancel = null;
  }

  confirmCancelSubscription(): void {
    console.log('confirmCancelSubscription triggered!!');
    this.cancelSubscriptionClicked = true;
    this.showLoader = true;
    const subscriptionId = this.paymentToCancel?.paymentDetails?.subscriptionId;
    console.log(
      'cancelSubscriptionRefundOption: ',
      this.cancelSubscriptionRefundOption
    );
    this.globalApiService
      .cancelSubscription(subscriptionId, this.cancelSubscriptionRefundOption)
      .subscribe({
        next: (response) => {
          this.showLoader = false;
          this.cancelSubscriptionClicked = false;
          this.notifier.notify(
            'success',
            'Subscription cancelled successfully.'
          );
          this.closeCancelSubscriptionModal();
          this.getPayments(this.pageIndex);
        },
        error: (err) => {
          this.showLoader = false;
          this.cancelSubscriptionClicked = false;
          console.log('err - cancel subscription: ', err);
          this.notifier.notify('error', 'Unable to cancel the subscription.');
        }
      });
  }

  openDeleteInvoiceModal(payment: any): void {
    this.paymentToDelete = payment;
    this.showDeleteInvoiceDialog = true;
  }

  closeDeleteInvoiceModal(): void {
    this.showDeleteInvoiceDialog = false;
    this.paymentToDelete = null;
  }

  confirmDeleteInvoice(): void {
    console.log('confirmDeleteInvoice triggered!!');
    this.deleteInvoiceClicked = true;
    this.showLoader = true;
    this.globalApiService
      .deleteInvoice(this.paymentToDelete?.invoiceId)
      .subscribe({
        next: (response) => {
          this.showLoader = false;
          this.deleteInvoiceClicked = false;
          this.notifier.notify('success', 'Invoice deleted successfully.');
          this.closeDeleteInvoiceModal();
          this.getPayments(this.pageIndex);
        },
        error: (err) => {
          this.showLoader = false;
          this.deleteInvoiceClicked = false;
          console.log('err - delete invoice: ', err);
          this.notifier.notify('error', 'Unable to delete the invoice.');
        }
      });
  }

  checkoutInvoice(transaction: any): void {
    console.log('checkoutInvoice triggered!!');
    this.showLoader = true;
    console.log('selectedTransaction: ', transaction);
    this.globalApiService.downloadInvoice(transaction?.receiptId).subscribe({
      next: (response) => {
        this.showLoader = false;
        console.log('response - downloadInvocie: ', response);
        const data = response?.data;
        window.open(data?.invoiceUrl, '_blank');
      },
      error: (err) => {
        this.showLoader = false;
        console.log('err - download invoice: ', err);
        this.notifier.notify('error', 'Unable to checkout the invoice.');
      }
    });
  }
}
